// extracted by mini-css-extract-plugin
module.exports = {"Video":"styles_Video__g4hI8"};